import { render, staticRenderFns } from "./EditCompanyInfoChange.vue?vue&type=template&id=648418c1&"
import script from "./EditCompanyInfoChange.vue?vue&type=script&lang=js&"
export * from "./EditCompanyInfoChange.vue?vue&type=script&lang=js&"
import style0 from "./EditCompanyInfoChange.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports